<ng-container *ngIf="resendCodeRequest$ | async"></ng-container>
<ng-container *ngIf="requestCodeOperation$ | async"></ng-container>

<div class="modal-body" [formGroup]="codeForm">
  <app-message *ngIf="errorObject.isError" [message]="errorObject.message" [type]="errorObject.type"></app-message>
  <div class="panel-item">
    <label class="panel-label">Телефон</label>
    <input formControlName="login" readonly prefix="+7" mask=" (000) 000 00 00" type="text" class="panel-input login">
  </div>

  <div class="panel-item">
    <label class="panel-label">Код</label>
    <input formControlName="code" class="panel-input" mask="0000" type="text" placeholder="0000">
  </div>
  <div class="panel-item" *ngIf="codeResendInFly === false">
    <button class="panel-btn-link" type="button" (click)="resendCode()">Не пришёл код?</button>
  </div>
  <ng-container *ngIf="resendCodeAfter$ | async as timer">
    <div class="panel-item resend-code"> {{timer > 0 ? 'Повторно запросить код можно будет через ' + timer : ''}}</div>
  </ng-container>
  <div class="panel-action-btns">
    <app-button
    [buttonClass]="'big-gray-light'"
    [text]="'Отредактировать номер'"
    [styleInline]="{ 'height': '100%' }"
    (buttonClick)="stepBack()"
  ></app-button>
    <app-button
    [buttonClass]="'big-purple-gradient'"
    [text]="'Войти'"
    (buttonClick)="sendCode()"
    [disabled]="codeForm.invalid || isSendCode"
    [styleInline]="{ 'height': '100%', 'width': '100%' }"
  ></app-button>
  </div>
</div>